import { Tr } from '@chakra-ui/react';
import { useGenericContext } from 'components/contexts/useGenericContext';
import { IndustryForm } from 'components/forms';
import { Td, TdActions, TdTag } from 'components/lib';
import { CustomTable, FormDrawer } from 'components/modules';
import { FormikProps } from 'formik';
import { getId, getResults, isResultsEmpty } from 'helpers';
import { nanoid } from 'nanoid';
import { useCallback, useRef } from 'react';
import {
  IIndustryPayload,
  IIndustryResource,
} from 'services/resources/preferences/types.d';

import { getCreated, getIcon, getName, HEADERS } from '../helpers';

export const Page: React.FC = (): JSX.Element => {
  const {
    active,
    defaultPatch,
    defaultRestore,
    isDrawerOpen,
    onPrepareDelete,
    onPrepareDrawer,
    registry,
    state,
    toggleDrawer,
  } = useGenericContext<IIndustryResource>();

  const ref = useRef<FormikProps<IIndustryPayload>>(null);

  const prepareOnSubmit = useCallback(() => {
    if (ref?.current) ref?.current?.submitForm();
  }, [ref]);

  return (
    <>
      <CustomTable
        isEmpty={isResultsEmpty(state)}
        headers={HEADERS}
        isLoading={state?.loading}
        mx={8}
      >
        {getResults(state)?.map((row: IIndustryResource) => (
          <Tr key={nanoid()} position="relative">
            <Td>{getId(row)}</Td>
            <Td>{getName(row)}</Td>
            <TdTag>{getIcon(row)}</TdTag>
            <Td>{getCreated(row)}</Td>
            <TdActions
              isActive={active}
              onDelete={() => onPrepareDelete(row)}
              onRestore={() => defaultRestore(row, { is_active: true })}
              onUpdate={() => onPrepareDrawer(row)}
            />
          </Tr>
        ))}
      </CustomTable>

      <FormDrawer
        isOpen={isDrawerOpen}
        isDisabled={!!ref?.current?.isSubmitting || !!ref?.current?.isValid}
        isLoading={!!ref.current?.isSubmitting}
        onClose={toggleDrawer}
        onSubmit={prepareOnSubmit}
      >
        <IndustryForm
          initialValues={{ ...registry }}
          onSubmit={defaultPatch}
          ref={ref}
        />
      </FormDrawer>
    </>
  );
};
